import request from "@/utils/request.js";
import { getFormatParams } from "@/utils";
export function login(data) {
  return request.post("/connect/token", data);
}
export function getUser(data) {
  return request.get("/api/app/session/current-login-user-informations", data);
}
export function getMenu(data) {
  return request.get("/api/app/user-auth/user-auth-config", data);
}

// 获取租户列表
export function getTenants(data) {
  return request.get("/api/app/login-for-tenant/tenants" + getFormatParams(data));
}
